module.exports = {
  title:'浦江县绿色管理服务平台不见面开标大厅',
  title2:'不见面开标大厅',
  systemTitle: '浦江县绿色管理服务平台',
  serviceTel:'',
  lanChenPhone:'191 0650 6216',
  caCheckUrl :process.env.VUE_APP_NODE === 'development'? "https://tca.zhaotx.cn/api/v1/ca-center/verify/ca":"https://ca.zhaotx.cn/api/v1/ca-center/verify/ca",
  stystemLx :process.env.VUE_APP_STYSTEM,  // ztx hz lh
  loginHost: '/logout',
  clientName: 'kbdt',
  websocketHost: process.env.VUE_APP_WS_HOST,
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false
}
